export * from './ProductDetails.ui';
